module.exports = __webpack_public_path__ + "static/media/location-slash.6f088c16.svg";